export class Options {
  candidateCustomQuery: string;
  contactCustomQuery: string;
  companyCustomQuery: string;
  notificationEmail: string;
  sanitisedWords: string;
  isDryRun: boolean;
  nightlyRun: boolean;
  worksiteObjectType: string;
  worksiteContactField: string;
  worksiteJobField: string;
  worksitePlacementField: string;
  mergeCandidateSkillsAndCategories: boolean;
  mergeContactSkillsAndCategories: boolean;
  mergeCandidateSpecialties: boolean;
  mergeClientContactSpecialties: boolean;
  fieldLevelMergeCandidate: boolean;
  fieldLevelMergeContact: boolean;
  fieldLevelMergeCompany: boolean;
  locationsMergeCompany: boolean;
  mergeTearsheets: boolean;
  mergePersonCustomObjects: boolean;
  candidateCustomQueryEditable: boolean;
  contactCustomQueryEditable: boolean;
  companyCustomQueryEditable: boolean;
  maxDuplicatesPerMaster: number;

  constructor(
    candidateCustomQuery: string = '',
    contactCustomQuery: string = '',
    companyCustomQuery: string = '',
    notificationEmail: string = '',
    sanitisedWords: string = '',
    isDryRun: boolean = false,
    nightlyRun: boolean = false,
    worksiteObjectType: string = '',
    worksiteContactField: string = '',
    worksiteJobField: string = '',
    worksitePlacementField: string = '',
    mergeCandidateSkillsAndCategories: boolean = true,
    mergeContactSkillsAndCategories: boolean = false,
    mergeCandidateSpecialties: boolean = false,
    mergeClientContactSpecialties: boolean = false,
    fieldLevelMergeCandidate: boolean = false,
    fieldLevelMergeContact: boolean = false,
    fieldLevelMergeCompany: boolean = false,
    locationsMergeCompany: boolean = false,
    mergeTearsheets: boolean = false,
    mergePersonCustomObjects: boolean = false,
    candidateCustomQueryEditable: boolean = false,
    contactCustomQueryEditable: boolean = false,
    companyCustomQueryEditable: boolean = false,
    maxDuplicatesPerMaster: number = 5
  ) {
    this.candidateCustomQuery = candidateCustomQuery;
    this.contactCustomQuery = contactCustomQuery;
    this.companyCustomQuery = companyCustomQuery;
    this.notificationEmail = notificationEmail;
    this.sanitisedWords = sanitisedWords;
    this.isDryRun = isDryRun;
    this.nightlyRun = nightlyRun;
    this.worksiteObjectType = worksiteObjectType;
    this.worksiteContactField = worksiteContactField;
    this.worksiteJobField = worksiteJobField;
    this.worksitePlacementField = worksitePlacementField;
    this.mergeCandidateSkillsAndCategories = mergeCandidateSkillsAndCategories;
    this.mergeContactSkillsAndCategories = mergeContactSkillsAndCategories;
    this.mergeCandidateSpecialties = mergeCandidateSpecialties;
    this.mergeClientContactSpecialties = mergeClientContactSpecialties;
    this.fieldLevelMergeCandidate = fieldLevelMergeCandidate;
    this.fieldLevelMergeContact = fieldLevelMergeContact;
    this.fieldLevelMergeCompany = fieldLevelMergeCompany;
    this.locationsMergeCompany = locationsMergeCompany;
    this.mergeTearsheets = mergeTearsheets;
    this.mergePersonCustomObjects = mergePersonCustomObjects;
    this.candidateCustomQueryEditable = candidateCustomQueryEditable;
    this.contactCustomQueryEditable = contactCustomQueryEditable;
    this.companyCustomQueryEditable = companyCustomQueryEditable;
    this.maxDuplicatesPerMaster = maxDuplicatesPerMaster;
  }
}
